import { WorkoutsRepository } from "../../infra/repository/workout.repository";
import { Workout } from "../domain/workout";

interface ListWorkoutResponse {
    workouts: Workout[];
    drill: string;
}
export class ListWorkoutsUseCase {
    static async execute(drillId: string): Promise<ListWorkoutResponse> {
        try {
            const response = await WorkoutsRepository.list(drillId);
            if (response.error) throw Error("Erro ao listar treinos");
            return {
                workouts: response.data.workouts,
                drill: response.data.drill
            };
        } catch (error) {
            throw Error("Erro ao listar treinos");
        }
    }
}